import type { FaireProductEntity } from "../../entity_types/product";

export const p_q3d7tea4d7: FaireProductEntity = {
  token: "p_q3d7tea4d7",
  type: "product",
  name: "Down at the Farm Sticker Book",
  brandToken: "b_d91ih48t8j",
  brandName: "Cupkin",
  imageUrl:
    "https://cdn.faire.com/fastly/3f4f0d9b8ea9916c59ca0187b1c4e2d76325d3a069ede74eddf26f14e1437b30.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/67bd9693cd2e05c06c7732d8fa32e47374fcf82e1cd1fb17f461aa98307e40e0.png",
    "https://cdn.faire.com/fastly/38d21dc531761ac57c4d018ab2db68e22772f38364b8bef3558c5ac53728c75f.png",
    "https://cdn.faire.com/fastly/f2748c138bd406367e7e12d9496b458a7cc4ed3b4983ccd5073dab76f47a5edd.png",
  ],
  priceDollars: 12.74,
  description:
    "🐓 Bring the Barnyard to Life with the Down at the Farm Sticker Book! 🌾\n\nSaddle up for some country fun with 500+ farm-themed stickers! From playful piglets and fluffy sheep to tractors, barns, and bountiful crops, this sticker book captures all the charm of life on the farm. Perfect for decorating journals, planners, and scrapbooks — or creating your own bustling barnyard scenes!\n\n✨ Why you’ll love it:\n🚜 500+ delightful designs — featuring farm animals, tools, and classic countryside moments.\n🌻 Easy-peel stickers — simple and fun for all ages.\n🐄 Craft your own farm story — build a lively barnyard or peaceful pasture on every page.\n🌾 For animal and nature lovers — a fun way to explore farm life without leaving home!\n\nWhether you're a farm fan or just love the cozy countryside vibe, this sticker book is your ticket to a day in the hay.\n\nReady to harvest some creativity? Let’s go down to the farm! 🐓🌿\n",
  tags: [],
  msrpDollars: 16.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:56.967Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
